export enum SearchLoggerEventName {
  NonFaceToFaceDiagnosisClickInSnippet = 'non_face_to_face_diagnosis_click_in_snippet',
  NonFaceToFacePrescriptionClickInSnippet = 'non_face_to_face_prescription_click_in_snippet',
  FindPharmacyClickInSnippetFeature = 'find_pharmacy_click_in_snippet_feature',
  EmergencyContraceptiveClickInSnippetFeature = 'emergency_contraceptive_click_in_snippet_feature',
  DietInjectionClickInSnippetFeature = 'diet_injection_click_in_snippet_feature',
}
